import { CourseTileData } from '../../components/CourseTile/types';
import { SelectorOption } from '../../components/Forms/Selector/types';
import { InstitutionSummary } from '../../../ReduxStorage/Institutions/types';

export enum ActionTypes {
  COURSE_LISTING_DATA_START = 'COURSE_LISTING_DATA_START',
  COURSE_LISTING_DATA_LOADED = 'COURSE_LISTING_DATA_LOADED',
  COURSE_LISTING_SEARCH_COURSES_SUCCESS = 'COURSE_LISTING_SEARCH_COURSES_SUCCESS',
  COURSE_LISTING_SEARCH_COURSES_FAILURE = 'COURSE_LISTING_SEARCH_COURSES_FAILURE',
  COURSE_LISTING_LOAD_MORE_SUCCESS = 'COURSE_LISTING_LOAD_MORE_SUCCESS',
}

export type CourseListingDataStartAction = {
  type: ActionTypes.COURSE_LISTING_DATA_START;
  requestId: number;
};

export type CourseListingDataLoadedAction = {
  type: ActionTypes.COURSE_LISTING_DATA_LOADED;
  featuredCourses: CourseTileData[];
  featuredInstitutions: SelectorOption[];
  categories: string[];
};

export interface CourseListingSearchCoursesSuccessAction {
  type: ActionTypes.COURSE_LISTING_SEARCH_COURSES_SUCCESS;
  requestId: number;
  courses: CourseTileData[];
  total: number;
}

export interface CourseListingSearchCoursesFailureAction {
  type: ActionTypes.COURSE_LISTING_SEARCH_COURSES_FAILURE;
  requestId: number;
  error: string;
}

export interface CourseListingLoadMoreSuccessAction {
  type: ActionTypes.COURSE_LISTING_LOAD_MORE_SUCCESS;
  requestId: number;
  courses: CourseTileData[];
  total: number;
}

export const COURSE_MARKETING_FILTERS_LOADED =
  'COURSE_MARKETING_FILTERS_LOADED';

export interface CourseMarketingFiltersLoadedAction {
  type: 'COURSE_MARKETING_FILTERS_LOADED';
  featuredInstitutions: InstitutionSummary[];
  featuredCourses: CourseTileData[];
  categories: string[];
  courseTypes: SelectorOption[];
}

export type CourseListingAction =
  | CourseListingDataStartAction
  | CourseListingDataLoadedAction
  | CourseListingSearchCoursesSuccessAction
  | CourseListingSearchCoursesFailureAction
  | CourseListingLoadMoreSuccessAction
  | CourseMarketingFiltersLoadedAction;
